const CALL_HISTORY_KEYWORD = {
  ALL_CALL_HISTORY: "allCallsHistory",
  INCOMING_CALLS: "incomingCalls",
  OUTGOING_CALLS: "outgoingCalls",
  MISSED_CALLS: "missedCalls",
};

export { CALL_HISTORY_KEYWORD };
